import React from 'react';

export const offersConfig = [
  {
    index: 0,
    keyname: "free",
    title: "🎁 Free",
    commissionRate: 0,
    featuresElements: [
      "✓ <b>500</b> crédits messages par mois",
      "✓ Chatting 100% automatisé",
      "✓ <span class=\"theme-accent\">Accès CRM complet</span>"
    ],
    features: {
      messages: 500
    },
    pricing: 0,
    pricingElement: <p className="pricing-price">Gratuit<span className="pricing-currency">(Limité à 2 mois)</span></p>,
    beginner: true
  }, {
    index: 1,
    keyname: "starter",
    title: "🌱 Starter",
    commissionRate: 5,
    featuresElements: [
      "✓ <b>3 500</b> crédits messages par mois",
      "✓ Chatting 100% automatisé",
      "✓ <span class=\"theme-accent\">Accès CRM complet</span>"
    ],
    features: {
      messages: 3500
    },
    pricing: 29,
    pricingElement: <p className="pricing-price">29<span className="pricing-currency">€ /mois</span></p>,
    beginner: true
  }, {
    index: 2,
    keyname: "boost",
    title: "🚀 Boost",
    commissionRate: 5,
    featuresElements: [
      "✓ <b>6 000</b> crédits messages par mois",
      "✓ Chatting 100% automatisé",
      "✓ <span class=\"theme-accent\">Accès CRM complet</span>"
    ],
    features: {
      messages: 6000
    },
    pricing: 49,
    pricingElement: <p className="pricing-price">49<span className="pricing-currency">€ /mois</span></p>,
    beginner: true
  }, {
    index: 3,
    keyname: "stars",
    title: "✨ Star",
    commissionRate: 5,
    featuresElements: [
      "✓ <b>13 000</b> crédits messages par mois",
      "✓ Chatting 100% automatisé",
      "✓ <span class=\"theme-accent\">Accès CRM complet</span>"
    ],
    features: {
      messages: 13000
    },
    pricing: 99,
    pricingElement: <p className="pricing-price">99<span className="pricing-currency">€ /mois</span></p>,
    beginner: false
  }, {
    index: 4,
    keyname: "superstars",
    title: "🌟 Super Star",
    commissionRate: 5,
    featuresElements: [
      "✓ <b>27 000</b> crédits messages par mois",
      "✓ Chatting 100% automatisé",
      "✓ <span class=\"theme-accent\">Accès CRM complet</span>"
    ],
    features: {
      messages: 27000
    },
    pricing: 199,
    pricingElement: <p className="pricing-price">199<span className="pricing-currency">€ /mois</span></p>,
    beginner: false
  }, {
    index: 5,
    keyname: "legends",
    title: "🏆 Légende",
    commissionRate: 5,
    featuresElements: [
      "✓ <b>70 000</b> crédits messages par mois",
      "✓ Chatting 100% automatisé",
      "✓ <span class=\"theme-accent\">Accès CRM complet</span>"
    ],
    features: {
      messages: 70000
    },
    pricing: 499,
    pricingElement: <p className="pricing-price">499<span className="pricing-currency">€ /mois</span></p>,
    beginner: false
  }
];
